exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cta-solution-container{display:flex;flex:1;padding:0;margin-bottom:100px;gap:16px}@media screen and (max-width: 992px){.cta-solution-container{flex-direction:column}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Common/CtaSolution/CtaSolution.scss
// module id = 8164
// module chunks = 13